import {
  Component,
  ElementRef,
  OnInit,
  TemplateRef,
  ViewChild,
  HostListener,
} from '@angular/core';
import { Router } from '@angular/router';
import { EstampService } from '../../../services/estamp.service';
import { MessageService } from 'primeng/api';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import { StorageService } from 'src/app/services/storage.service';
import { LoaderService } from 'src/app/services/loader.service';
import { CatUploadService } from 'src/app/services/cat-upload.service';
import { OrderConfirmationDetailsComponent } from 'src/app/shared-components/order-confirmation-details/order-confirmation-details.component';
import { ConfirmationService, ConfirmEventType } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
interface Mime {
  mime: string;
  pattern: (number | undefined)[];
}

const imageMimes: Mime[] = [
  {
    mime: 'application/pdf',
    pattern: [0x25, 0x50, 0x44, 0x46],
  },
];
@Component({
    selector: 'app-e-stamp-form',
    templateUrl: './e-stamp-form.component.html',
    styleUrls: ['./e-stamp-form.component.scss'],
    standalone: false
})
export class EStampFormComponent implements OnInit {
  @ViewChild('reviewOrder') reviewOrder: TemplateRef<any>;
  @ViewChild('paymentScreen') paymentScreen: TemplateRef<any>;

  reviewOrderData: any;
  @ViewChild('closeUploadPopupBtn') closeUploadPopupBtn!: ElementRef;

  selectedBranch: any;
  showEstampDetails: boolean = true;
  showConfirmation: boolean = false;
  fileName: string = 'Browse';
  selectedDocumentType = '';
  uploadFile!: File;
  //-------------------------Step Active --------------------------------------//
  active_eStamp: boolean = false;
  active_confirm: boolean = false;
  //-------------------Import & export variables ----------------------------//
  estampData: any;
  orderConfirmationData: any = { service: 'E-Stamp' };
  @ViewChild('orderDetails') orderDetails!: OrderConfirmationDetailsComponent;
  order_reviewer: any;
  userRole: string;
  paymentDetails: {
    payeeName: string;
    payeeEmail: string;
    payeeMobileNumber: string;
    payNow: string;
    paymentMethod: string;
  };
  paymentOrderData: any;
  order_payment: boolean = true;
  stateCode: string;
  isSignerEnable: any;
  account_id: any;
  isWallet: boolean = false;
  virtualAccountNo: string;
  //------------------------------------------------------------------------------//
  constructor(
    private router: Router,
    private userDashboardService: UserDashboardService,
    private storageService: StorageService,
    private estampService: EstampService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private primeng: PrimeNG,
    private modalService: NgbModal,
    private loader: LoaderService,
    private catUploadService: CatUploadService
  ) {
    this.storageService.setContractType(false);

    this.order_reviewer = this.storageService.getOrderReviewConsent() || null;
    this.userRole = this.storageService.getRole() || null;
    this.account_id = this.storageService.getAccountId() || null;
    this.storageService.getSignerValue.subscribe((res) => {
      this.isSignerEnable = res;
    });
    this.virtualAccountNo = this.storageService.getVirtualAccountNumber();
    this.isWallet = this.storageService.getIsWallet();
  }

  ngOnInit(): void {
    this.primeng.ripple.set(true);
  }

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: Event) {
    event.preventDefault();
    event.returnValue = false;
  }

  onestampDataChange(data: any): void {
    this.order_payment = data.paymentbySigner;
    this.paymentDetails = {
      payeeName: data.payeeName,
      payeeEmail: data.payeeEmail,
      payeeMobileNumber: data.payeeMobileNumber,
      paymentMethod: data.paymentMethod,
      payNow: '',
    };
    this.stateCode = data.state_code;
    this.estampData = data;

    this.estampData.referenceNumber = this.estampData.referenceNumber.trim();
    if (this.estampData.referenceNumber === '') {
      this.messageService.add({
        severity: 'warn',
        detail: 'Please fill Reference Number',
      });
    } else {
      this.postEstampData();
    }
  }

  postEstampData() {
    var estamps: any = [];
    this.selectedBranch = this.estampData.documentDetailsForm[0].selectBranch;
    this.estampData.documentDetailsForm.forEach((estamp) => {
      estamps.push({
        first_party_name: estamp.firstPartyName,
        second_party_name: estamp.secondPartyName,
        stamp_duty_paid_by: estamp.stampDutyPaidBy,
        article_id: estamp.articleNumber,
        stamp_duty_amount: estamp.stampDutyValue,
        consideration_amount: estamp.considerationPrice,
        description: estamp.purposeOfStampDuty,
        execution_date: estamp.execution_date.getTime(),
        place: estamp.place,
        process_type: estamp.process_type,
        first_party_pan: estamp.first_party_pan,
        second_party_pan: estamp.second_party_pan
      });
    });

    var data = {
      is_bulk: false,
      order_details: [
        {
          account_id: this.account_id,
          branch_id: this.selectedBranch.id,
          referance_id: this.estampData.referenceNumber,
          estamps: estamps,          
        },
      ],
      stateCode: this.stateCode,
    };
    if (this.order_reviewer) {
      // this.confirmOrder(data);
      const reviewData = { serviceType: 'E-stamp', details: data };
      this.reviewOrderData = reviewData;
      this.onApproveMethod();
    } else if (this.order_payment && this.isSignerEnable) {
      this.getPayment(data);
      const reviewData = { serviceType: 'E-stamp', details: data };
      this.reviewOrderData = reviewData;
    } else {
      this.placeOrderData(data);
    }
  }

  reviewOrderDataChange(data: any) {
    this.closeModel();
    if (data.path === 'order') {
      this.placeOrderData(data.details);
    }
  }

  // confirmOrder(data) {
  //   this.confirmationService.confirm({
  //     message: 'Do you want to get your request to be reviewed by Checker?',
  //     header: 'Confirmation',
  //     icon: 'pi pi-exclamation-circle',
  //     accept: () => {
  //       this.placeOrderData(data);
  //     },
  //     acceptLabel: 'No , Proceed to Place Order',
  //     acceptIcon: 'pi pi',
  //     reject: (type) => {
  //       switch (type) {
  //         case ConfirmEventType.REJECT:
  //           this.onApproveMethod();
  //           break;
  //         case ConfirmEventType.CANCEL:
  //           break;
  //       }
  //     },
  //     rejectLabel: 'Yes',
  //     rejectIcon: 'pi pi'
  //   });
  // }
  closeModel() {
    this.modalService.dismissAll();
  }
  onApproveMethod() {
    this.modalService
      .open(this.reviewOrder, {
        // Use this.reviewOrder directly
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
  }

  placeOrderData(data) {
    if (this.order_payment && this.isSignerEnable) {
      this.getPayment(data);
      return;
    }
    this.estampService.postEstampData(data).subscribe(
      (resp) => {
        if (resp.status == 200) {
          this.messageService.add({
            severity: 'success',
            summary: 'Order Placed!',
            detail: resp.message,
          });
          this.getOrderConfirmation(resp.content.order_id);
          const value = this.estampData.page;
          this.gotToCatEditScreen(value);
        }
      },
      (err) => {
        if (
          'error' in err &&
          'content' in err.error &&
          'errors' in err.error.content
        ) {
          for (let i = 0; i < err.error.content.errors.length; i++) {
            this.messageService.add({
              severity: 'error',
              detail: err.error.content.errors[i],
            });
          }
        }
      }
    );
  }
  getOrderConfirmation(orderId) {
    this.loader.show();
    let reqParams = {
      order_ids: orderId.toString(),
      detail: 1,
    };
    this.catUploadService
      .getOrderConfirmation(reqParams)
      .subscribe((res: any) => {
        if (res.status === 200) {
          this.catUploadService.orderDetails = res.content[0].order;
          this.orderDetails.getPlacedOrderDetails();
        }
      });
  }

  onOrderConfirmationChange(data: any): void {
    this.orderConfirmationData = data;
  }

  //-------------------------------------------------------------------------------------------------//

  //-------- to Display the required component depending on the click of the stepper------------//

  gotToCatEditScreen(value: string): void {
    this.showEstampDetails = value === 'estamp';
    this.showConfirmation = value === 'confirmation';
    this.setActiveTab(value);
  }

  //------------Change the color of the stepper on completion ------------------------------//

  setActiveTab(value: string) {
    if (value === 'estamp') {
      this.active_eStamp = false;
      this.active_confirm = false;
    } else {
      this.active_eStamp = true;
      this.active_confirm = value === 'confirmation';
    }
  }

  gotoDashboard() {
    this.router.navigate(['doqfy/dashboard']);
  }

  back() {
    this.userRole === 'CLIENT'
      ? this.router.navigate(['doqfy/dashboard'])
      : this.router.navigate(['doqfy/admin-dashboard']);
  }

  onFileChange(event: any) {
    this.closeUploadPopupBtn.nativeElement.click();
    let files = event.target.files;
    this.fileName = files[0].name;
    const fileSize = files[0].size / 1024 / 1024;
    if (fileSize > 10) {
      alert('File should be less than 10MB in size');

      return;
    }
    let splitName = files[0].name.split('.');
    if (splitName[splitName.length - 1] !== 'pdf') {
      alert('Not a valid PDF file. Please upload another one');

      return;
    } else if (splitName.length > 2) {
      alert('File name should have only single extension');

      return;
    }

    let $img: any = document.querySelector('#upload_file');

    if (typeof FileReader !== 'undefined') {
      let reader = new FileReader();
      reader.readAsArrayBuffer($img.files[0]);
    }

    this.validateImageMimeType(files[0], (valid) => {
      if (!valid) {
        alert('Not a valid PDF file. Please upload another one');
      } else {
        this.uploadFile = files[0];
      }
    });
  }

  isMime(bytes: Uint8Array, mime: Mime): boolean {
    return mime.pattern.every((p, i) => !p || bytes[i] === p);
  }

  validateImageMimeType(file: File, callback: (b: boolean) => void) {
    const numBytesNeeded = Math.max(...imageMimes.map((m) => m.pattern.length));
    const blob = file.slice(0, numBytesNeeded);

    const fileReader = new FileReader();

    fileReader.onloadend = (e) => {
      if (!e || !fileReader.result) return;

      const bytes = new Uint8Array(fileReader.result as ArrayBuffer);

      const valid = imageMimes.some((mime) => this.isMime(bytes, mime));

      callback(valid);
    };

    fileReader.readAsArrayBuffer(blob);
  }

  getArticleCode(content) {
    this.modalService
      .open(content, {
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
  }

  getPayment(Obj) {
    this.paymentOrderData = {
      orderDetails: Obj,
      payment: this.paymentDetails,
      stateCode: this.stateCode,
      service_type: 'E-Stamp',
    };

    this.modalService
      .open(this.paymentScreen, {
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
  }

  paymentOrderDataChange(event) {
    if (event.status === 200) {
      this.messageService.add({
        severity: 'success',
        summary: 'Order Placed successfully!',
        detail: event.message,
      });
      this.closeModel();
    }
  }
}
